import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProveedorEdit from '../../components/Proveedor/proveedorNuevo';
import { sagaSaveProveedor, sagaGetProveedor } from '../../reducers/proveedoresReducer/actions';
import { proveedoresEditSelector } from '../../selectors/proveedoresSelector';
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector';
import * as Notification from '../../components/Common/notification';

class ProveedorEditContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            proveedor: {
                idProveedor: 0,
                nombreProveedor: '',
                codigo: '',
            },
            error: null
        };
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        if (params.idProveedor && params.idProveedor !== '0') {
            this.props.sagaGetProveedor(params.idProveedor);
        } else {
            this.setState({
                proveedor: {
                    idProveedor: 0,
                    nombreProveedor: '',
                    codigo: '',
                },
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.proveedor !== this.props.proveedor) {
            this.setState({ proveedor: this.props.proveedor.proveedor });
        }
    }

    handleOnChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            proveedor: {
                ...prevState.proveedor,
                [name]: value,
            }
        }));
    }

    handleOnSave = () => {
        const { nombreProveedor, idProveedor } = this.state.proveedor;

        if (nombreProveedor) {
            this.props.sagaSaveProveedor({ 
                ...this.state.proveedor,
                idProveedor: idProveedor,
                idInstalacion: this.props.instalacion.id,
                codigo: Math.floor(Math.random() * 10000),
            }).then(() => {
                this.props.history.push('/Proveedores/');
            }).catch((error) => {
                Notification.showError("Error al guardar el proveedor", error);
            })
        } else {
            Notification.showError("El nombre del proveedor es requerido");
        }
    }

    render() {
        return (
            <ProveedorEdit 
                entidad="Proveedor"
                proveedor={this.state.proveedor}
                handleOnChange={this.handleOnChange}
                handleOnSave={this.handleOnSave}
                handleOnCancel={() => this.props.history.push('/Proveedores/')}
                error={this.state.error}
            />
        );
    }
};

ProveedorEditContainer.propTypes = {
    proveedor: PropTypes.object,
    usuario: PropTypes.object,
    instalacion: PropTypes.object,
    sagaSaveProveedor: PropTypes.func.isRequired,
    sagaGetProveedor: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    proveedor: proveedoresEditSelector(state),
    usuario: usuarioSelector(state),
    instalacion: instalacionSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    sagaSaveProveedor,
    sagaGetProveedor,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProveedorEditContainer);